import React from "react";

export const RegalCrown = ({ size = 24, className = "", strokeWidth, ...rest }) => (
  <img
    src="/regal-crown.png"
    alt=""
    aria-hidden="true"
    style={{ height: Math.round(size * 1.3), width: "auto" }}
    className={className}
    draggable={false}
    {...rest}
  />
);

export default RegalCrown;
